import React, { useCallback, useMemo, useState } from "react";
import { cx } from "emotion";
// import { v1 as uuid } from "uuid";
import { Input } from "@cadmakers-ui/core";
import { FilterProps } from "@cadmakers/data-grid-v2";
import { uniq } from "lodash";
import { CheckItem } from "../../../../../Common/Components/CheckItem/CheckItem";
import styles from "./TitleRelationshipFilter.module.scss";
import { TitleRelationshipFooter } from "./TitleRelationshipFooter";
import { RelationshipFilterOptions } from "../../../../Constants/filterEnum";
import { getSelectedValue } from "./GetSelectedValue";
import { alphaNumeric } from "./AlphanumericSorter";

export const TitleRelationshipFilterSelect = React.memo<FilterProps<string[] | undefined>>(
  ({ flatRows, filterValue, setFilter, columnId, applyFilter, clearFilter, valueSelector }) => {
    const [search, setSearch] = useState("");

    const terms = useMemo<string[]>(
      () =>
        uniq(
          flatRows.map(row => {
            const value = getSelectedValue(row.values[columnId], valueSelector);

            return value;
          })
        )
          .filter(x => x)
          .sort(alphaNumeric),
      [flatRows, columnId, valueSelector]
    );

    const onApplyFilter = useCallback(() => {
      setFilter(filterValue?.length === 0 ? undefined : filterValue);
      applyFilter();
    }, [filterValue, applyFilter, setFilter]);

    const onClearFilter = useCallback(() => {
      clearFilter();
    }, [clearFilter]);

    return (
      <div className={styles.container}>
        <div className={styles.bottomborder} style={{ paddingBottom: "6px" }}>
          <Input
            type="search"
            placeholder="Search..."
            value={search}
            onChange={event => {
              const { value } = event.target;

              setSearch(value);
            }}
            translate
          />
        </div>
        <div style={{ overflow: "auto", flex: "1 1 auto" }}>
          <div className={cx(styles.bottomborder, styles.padded)}>
            <CheckItem
              label="Select All"
              checked={filterValue?.includes(RelationshipFilterOptions.All)}
              onChange={event => {
                const { checked } = event.target;
                if (checked) {
                  setFilter([...(filterValue ?? []), RelationshipFilterOptions.All]);
                } else {
                  setFilter(filterValue?.filter(term => term !== RelationshipFilterOptions.All));
                }
              }}
            />
            <CheckItem
              label="Parent Feedbacks"
              checked={filterValue?.includes(RelationshipFilterOptions.Parent)}
              onChange={event => {
                const { checked } = event.target;
                if (checked) {
                  setFilter([...(filterValue ?? []), RelationshipFilterOptions.Parent]);
                } else {
                  setFilter(filterValue?.filter(term => term !== RelationshipFilterOptions.Parent));
                }
              }}
            />
            <CheckItem
              label="Child Feedbacks"
              checked={filterValue?.includes(RelationshipFilterOptions.Child)}
              onChange={event => {
                const { checked } = event.target;
                if (checked) {
                  setFilter([...(filterValue ?? []), RelationshipFilterOptions.Child]);
                } else {
                  setFilter(filterValue?.filter(term => term !== RelationshipFilterOptions.Child));
                }
              }}
            />
            <CheckItem
              label="Non grouped Feedbacks"
              checked={filterValue?.includes(RelationshipFilterOptions.NonGrouped)}
              onChange={event => {
                const { checked } = event.target;
                if (checked) {
                  setFilter([...(filterValue ?? []), RelationshipFilterOptions.NonGrouped]);
                } else {
                  setFilter(
                    filterValue?.filter(term => term !== RelationshipFilterOptions.NonGrouped)
                  );
                }
              }}
            />
          </div>
          <div className={styles.padded}>
            {terms
              .filter(label => label.toLowerCase().includes(search.toLowerCase()))
              .map(label => (
                <CheckItem
                  label={label}
                  checked={filterValue?.includes(label)}
                  onChange={event => {
                    const { checked } = event.target;

                    if (checked) {
                      setFilter([...(filterValue ?? []), label]);
                    } else {
                      setFilter(filterValue?.filter(term => term !== label));
                    }
                  }}
                />
              ))}
          </div>
        </div>
        <TitleRelationshipFooter
          buttons={[
            {
              name: "apply",
              onClick: onApplyFilter
            },
            {
              name: "reset",
              onClick: onClearFilter
            }
          ]}
        />
      </div>
    );
  }
);
